import gql from "graphql-tag";

export const MY_TIME_MY_TIME_GET_WORK_TIME_WEEKLY_DATA = gql`
  query getWorkTimeWeeklyData($contractCode: String!, $date: Date!) {
    getWorkTimeWeeklyData(contractCode: $contractCode, date: $date) {
      weeklyVoluntaryOvertimeLimit
      weeklyWorktimeLimit
    }
  }
`;
